"use client";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import { Button } from "./ui/button";
import { Menu, X } from "lucide-react";

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const navItems = ["Home", "About us", "Blog" , "Contact us"];
  const mobileNavItems = ["Home", "About us", "Blog" , "Contact us"];

  return (
    <header 
      className={`sticky top-0 z-50 bg-white transition-all duration-300 ${
        isScrolled ? "shadow-sm" : "backdrop-blur-md"
      }`}
    >
      <div className={`container w-full transition-all duration-300 px-4 sm:px-6 lg:px-8`}>
        <div className="w-full flex justify-between items-center py-4">
          {/* Logo */}
          <div className="transition-all duration-300 w-[180px] md:w-[220px] lg:w-[300px] h-auto">
            <Image
              src="/Genaipulse-logo.png"
              alt="GenAi Pulse Logo"
              width={300}
              height={59}
              className="w-full h-full object-contain"
              priority
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8 w-[40%]">
            {navItems.map((item, index) => (
              <div key={index}>
                <a
                  href={
                    item == "Contact us" 
                    ?
                    "/contact"
                    :
                    item === "Home"
                      ? "/"
                      : item === "About us"
                      ? "/about"
                      : `/${item.toLowerCase()}`
                  }
                  className="relative text-lg text-sky-900 hover:text-sky-600 font-extrabold transition-colors px-2 py-1 group"
                >
                  {item}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-sky-600 group-hover:w-full transition-all duration-300" />
                </a>
              </div>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <Button
              variant="ghost"
              size="icon"
              className="text-sky-700 hover:bg-sky-100"
              onClick={toggleMobileMenu}
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </Button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white/95 backdrop-blur-lg rounded-lg shadow-xl mt-2 py-2 absolute left-4 right-4">
            {mobileNavItems.map((item, index) => (
              <a
                key={index}
                href={item === "Home" ? "/" : `${item.split(' ')[0].toLowerCase()}`}
                className="block py-3 px-6 text-gray-800 hover:bg-sky-50 rounded transition-colors border-b border-gray-100 last:border-0 hover:translate-x-1 transition-transform"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {item}
              </a>
            ))}
          </div>
        )}
      </div>
    </header>
  );
}